// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import LoginSuccessView from '@/views/LoginSuccessView.vue'
import UnauthorizedView from '@/views/UnauthorizedView.vue'
import ProductsView from '@/views/ProductsView.vue'
import MembersView from '@/views/MembersView.vue'
import CarouselView from "@/views/CarouselView.vue";
import AnnouncementView from "@/views/AnnouncementView.vue";
import ArticleView from "@/views/ArticleView.vue";
import OrderView from "@/views/OrderView.vue";
import SystemParameterView from "@/views/SystemParameterView.vue";
import DefaultCarrierView from "@/views/DefaultCarrierView.vue";
import ResourceManagement from '@/components/ResourceManagement.vue';
const adminPrefix = process.env.BASE_URL === '/admin/' ? '' : 'admin/';

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { requiresAuth: true },
    children: [
      {
        path: `${adminPrefix}carousel`,
        name: 'carousel',
        component: CarouselView,
        meta: { title: '首頁輪播圖' }
      },
      {
        path: `${adminPrefix}products`,
        name: 'products',
        component: ProductsView,
        meta: { title: '商品管理' }
      },
      {
        path: `${adminPrefix}categories`,
        name: 'categories',
        component: ResourceManagement,
        props: { resourceType: 'category' },
        meta: { title: '類別管理' }
      },
      { path: `${adminPrefix}templates`, name: 'templates', component: ResourceManagement, props: { resourceType: 'template' }, meta: { title: '商品模板管理' } },
      { path: `${adminPrefix}article-categories`, name: 'article-categories', component: ResourceManagement, props: { resourceType: 'article-category' }, meta: { title: '文章分類管理' } },
      { path: `${adminPrefix}article-tags`, name: 'article-tags', component: ResourceManagement, props: { resourceType: 'article-tag' }, meta: { title: '文章標籤管理' } },
      {
        path: `${adminPrefix}members`,
        name: 'members',
        component: MembersView,
        meta: { title: '會員管理' }
      },
      {
        path: `${adminPrefix}article`,
        name: 'article',
        component: ArticleView,
        meta: { title: '文章管理' }
      },
      {
        path: `${adminPrefix}announcements`,
        name: 'announcements',
        component: AnnouncementView,
        meta: { title: '公告欄' }
      },
      {
        path: `${adminPrefix}orders`,
        name: 'orders',
        component: OrderView,
        meta: { title: '訂單管理' }
      },
      {
        path: `${adminPrefix}system-parameters`,
        name: 'system-parameters',
        component: SystemParameterView,
        meta: { title: '系統參數' }
      },
      {
        path: `${adminPrefix}default-carriers`,
        name: 'default-carriers',
        component: DefaultCarrierView,
        meta: { title: '預設載具管理' }
      },
    ]},
  { path: '/login', name: 'login', component: LoginView },
  { path: '/login/success', name: 'login-success', component: LoginSuccessView },
  { path: '/unauthorized', name: 'unauthorized', component: UnauthorizedView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('jwt');

  // 沒 token，且此頁需要驗證，就導去 login
  if (to.meta.requiresAuth && !token) {
    return next('/login');
  }

  // 有 token，而且頁面需要登入，就解析角色
  if (token && to.meta.requiresAuth) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const role = payload.role;
      const exp = payload.exp; // 過期時間（秒）
      const now = Math.floor(Date.now() / 1000); // 現在時間（秒）

      // 如果 token 過期
      if (now >= exp) {
        console.warn('JWT 已過期');
        localStorage.removeItem('jwt'); // 清掉
        return next('/login');
      }

      // 如果不是 ADMIN
      if (role !== 'ADMIN') {
        return next('/unauthorized');
      }

    } catch (e) {
      console.error('JWT 解析錯誤', e);
      localStorage.removeItem('jwt'); // 清掉壞掉的 token
      return next('/login');
    }
  }

  next();
});

export default router
